import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  collections: {
    id: 'studio.iKi9+h',
    defaultMessage: 'App collections',
  },
  collectionsError: {
    id: 'studio.mewjmo',
    defaultMessage: 'There was a problem loading the app collections of this organization.',
  },
  search: {
    id: 'studio.xmcVZ0',
    defaultMessage: 'Search',
  },
  createCollection: {
    id: 'studio.K1y1Mm',
    defaultMessage: 'Create new app collection',
  },
  notAllowed: {
    id: 'studio.Uv9sdj',
    defaultMessage: 'You don’t have sufficient permissions to create app collections.',
  },
});
